var comMapping = {
	$mbytlist: [{
			label: "科目余额表",
			value: "KMYE"
		},
		{
			label: "进项增值税",
			value: "IINV"
		},{
			label:"开票数据",
			value:"OPEN_INVOICE_ACCOUNT"
		},
		{
			label:"合同台账",
			value:"CONTRACT"
		},
		{
			label:"红字信息表",
			value:"RED_LETTER"
		},
		{
			label:"旅客运输",
			value:"TRANSPORT"
		}
	],
	$winURl:window.location.origin,
	$sjlxoptions:[
		{
			label:"数据清册",
			value:"1"
		},
		{
			label:"税局下载",
			value:"2"
		},
		{
			label:"申报",
			value:"3"
		},
		{
			label:"缴款",
			value:"4"
		},
		{
			label:"pdf下载",
			value:"5"
		}
	],
	$suosqDataMapping:[
		{
			label:1,
			startval:'0101',
			endval:'0131'
		},
		{
			label:2,
			startval:'0201',
			endval:'0228'
		},
		{
			label:3,
			startval:'0301',
			endval:'0331'
		},
		{
			label:4,
			startval:'0401',
			endval:'0430'
		},
		{
			label:5,
			startval:'0501',
			endval:'0531'
		},
		{
			label:6,
			startval:'0601',
			endval:'0630'
		},
		{
			label:7,
			startval:'0701',
			endval:'0731'
		},
		{
			label:8,
			startval:'0801',
			endval:'0831'
		},
		{
			label:9,
			startval:'0901',
			endval:'0930'
		},
		{
			label:10,
			startval:'1001',
			endval:'1031'
		},
		{
			label:11,
			startval:'1101',
			endval:'1130'
		},
		{
			label:12,
			startval:'1201',
			endval:'1231'
		},
	],
	$kszjgxzqhdmdata:[
		{
		            "id":"110000",
		            "name":"北京市"
		        },
		        {
		            "id":"120000",
		            "name":"天津市"
		        },
		        {
		            "id":"130000",
		            "name":"河北省"
		        },
		        {
		            "id":"130100",
		            "name":"石家庄市"
		        },
		        {
		            "id":"130200",
		            "name":"唐山市"
		        },
		        {
		            "id":"130300",
		            "name":"秦皇岛市"
		        },
		        {
		            "id":"130400",
		            "name":"邯郸市"
		        },
		        {
		            "id":"130500",
		            "name":"邢台市"
		        },
		        {
		            "id":"130600",
		            "name":"保定市"
		        },
		        {
		            "id":"130700",
		            "name":"张家口市"
		        },
		        {
		            "id":"130800",
		            "name":"承德市"
		        },
		        {
		            "id":"130900",
		            "name":"沧州市"
		        },
		        {
		            "id":"131000",
		            "name":"廊坊市"
		        },
		        {
		            "id":"131100",
		            "name":"衡水市"
		        },
		        {
		            "id":"140000",
		            "name":"山西省"
		        },
		        {
		            "id":"140100",
		            "name":"太原市"
		        },
		        {
		            "id":"140200",
		            "name":"大同市"
		        },
		        {
		            "id":"140300",
		            "name":"阳泉市"
		        },
		        {
		            "id":"140400",
		            "name":"长治市"
		        },
		        {
		            "id":"140500",
		            "name":"晋城市"
		        },
		        {
		            "id":"140600",
		            "name":"朔州市"
		        },
		        {
		            "id":"140700",
		            "name":"晋中市"
		        },
		        {
		            "id":"140800",
		            "name":"运城市"
		        },
		        {
		            "id":"140900",
		            "name":"忻州市"
		        },
		        {
		            "id":"141000",
		            "name":"临汾市"
		        },
		        {
		            "id":"141100",
		            "name":"吕梁市"
		        },
		        {
		            "id":"150000",
		            "name":"内蒙古自治区"
		        },
		        {
		            "id":"150100",
		            "name":"呼和浩特市"
		        },
		        {
		            "id":"150200",
		            "name":"包头市"
		        },
		        {
		            "id":"150300",
		            "name":"乌海市"
		        },
		        {
		            "id":"150400",
		            "name":"赤峰市"
		        },
		        {
		            "id":"150500",
		            "name":"通辽市"
		        },
		        {
		            "id":"150600",
		            "name":"鄂尔多斯市"
		        },
		        {
		            "id":"150700",
		            "name":"呼伦贝尔市"
		        },
		        {
		            "id":"150800",
		            "name":"巴彦淖尔市"
		        },
		        {
		            "id":"150900",
		            "name":"乌兰察布市"
		        },
		        {
		            "id":"152200",
		            "name":"兴安盟"
		        },
		        {
		            "id":"152500",
		            "name":"锡林郭勒盟"
		        },
		        {
		            "id":"152900",
		            "name":"阿拉善盟"
		        },
		        {
		            "id":"210000",
		            "name":"辽宁省"
		        },
		        {
		            "id":"210100",
		            "name":"沈阳市"
		        },
		        {
		            "id":"210200",
		            "name":"大连市"
		        },
		        {
		            "id":"210300",
		            "name":"鞍山市"
		        },
		        {
		            "id":"210400",
		            "name":"抚顺市"
		        },
		        {
		            "id":"210500",
		            "name":"本溪市"
		        },
		        {
		            "id":"210600",
		            "name":"丹东市"
		        },
		        {
		            "id":"210700",
		            "name":"锦州市"
		        },
		        {
		            "id":"210800",
		            "name":"营口市"
		        },
		        {
		            "id":"210900",
		            "name":"阜新市"
		        },
		        {
		            "id":"211000",
		            "name":"辽阳市"
		        },
		        {
		            "id":"211100",
		            "name":"盘锦市"
		        },
		        {
		            "id":"211200",
		            "name":"铁岭市"
		        },
		        {
		            "id":"211300",
		            "name":"朝阳市"
		        },
		        {
		            "id":"211400",
		            "name":"葫芦岛市"
		        },
		        {
		            "id":"220000",
		            "name":"吉林省"
		        },
		        {
		            "id":"220100",
		            "name":"长春市"
		        },
		        {
		            "id":"220200",
		            "name":"吉林市"
		        },
		        {
		            "id":"220300",
		            "name":"四平市"
		        },
		        {
		            "id":"220400",
		            "name":"辽源市"
		        },
		        {
		            "id":"220500",
		            "name":"通化市"
		        },
		        {
		            "id":"220600",
		            "name":"白山市"
		        },
		        {
		            "id":"220700",
		            "name":"松原市"
		        },
		        {
		            "id":"220800",
		            "name":"白城市"
		        },
		        {
		            "id":"222400",
		            "name":"延边朝鲜族自治州"
		        },
		        {
		            "id":"230000",
		            "name":"黑龙江省"
		        },
		        {
		            "id":"230100",
		            "name":"哈尔滨市"
		        },
		        {
		            "id":"230200",
		            "name":"齐齐哈尔市"
		        },
		        {
		            "id":"230300",
		            "name":"鸡西市"
		        },
		        {
		            "id":"230400",
		            "name":"鹤岗市"
		        },
		        {
		            "id":"230500",
		            "name":"双鸭山市"
		        },
		        {
		            "id":"230600",
		            "name":"大庆市"
		        },
		        {
		            "id":"230700",
		            "name":"伊春市"
		        },
		        {
		            "id":"230800",
		            "name":"佳木斯市"
		        },
		        {
		            "id":"230900",
		            "name":"七台河市"
		        },
		        {
		            "id":"231000",
		            "name":"牡丹江市"
		        },
		        {
		            "id":"231100",
		            "name":"黑河市"
		        },
		        {
		            "id":"231200",
		            "name":"绥化市"
		        },
		        {
		            "id":"232700",
		            "name":"大兴安岭地区"
		        },
		        {
		            "id":"310000",
		            "name":"上海市"
		        },
		        {
		            "id":"320000",
		            "name":"江苏省"
		        },
		        {
		            "id":"320100",
		            "name":"南京市"
		        },
		        {
		            "id":"320200",
		            "name":"无锡市"
		        },
		        {
		            "id":"320300",
		            "name":"徐州市"
		        },
		        {
		            "id":"320400",
		            "name":"常州市"
		        },
		        {
		            "id":"320500",
		            "name":"苏州市"
		        },
		        {
		            "id":"320600",
		            "name":"南通市"
		        },
		        {
		            "id":"320700",
		            "name":"连云港市"
		        },
		        {
		            "id":"320800",
		            "name":"淮安市"
		        },
		        {
		            "id":"320900",
		            "name":"盐城市"
		        },
		        {
		            "id":"321000",
		            "name":"扬州市"
		        },
		        {
		            "id":"321100",
		            "name":"镇江市"
		        },
		        {
		            "id":"321200",
		            "name":"泰州市"
		        },
		        {
		            "id":"321300",
		            "name":"宿迁市"
		        },
		        {
		            "id":"330000",
		            "name":"浙江省"
		        },
		        {
		            "id":"330100",
		            "name":"杭州市"
		        },
		        {
		            "id":"330200",
		            "name":"宁波市"
		        },
		        {
		            "id":"330300",
		            "name":"温州市"
		        },
		        {
		            "id":"330400",
		            "name":"嘉兴市"
		        },
		        {
		            "id":"330500",
		            "name":"湖州市"
		        },
		        {
		            "id":"330600",
		            "name":"绍兴市"
		        },
		        {
		            "id":"330700",
		            "name":"金华市"
		        },
		        {
		            "id":"330800",
		            "name":"衢州市"
		        },
		        {
		            "id":"330900",
		            "name":"舟山市"
		        },
		        {
		            "id":"331000",
		            "name":"台州市"
		        },
		        {
		            "id":"331100",
		            "name":"丽水市"
		        },
		        {
		            "id":"340000",
		            "name":"安徽省"
		        },
		        {
		            "id":"340100",
		            "name":"合肥市"
		        },
		        {
		            "id":"340200",
		            "name":"芜湖市"
		        },
		        {
		            "id":"340300",
		            "name":"蚌埠市"
		        },
		        {
		            "id":"340400",
		            "name":"淮南市"
		        },
		        {
		            "id":"340500",
		            "name":"马鞍山市"
		        },
		        {
		            "id":"340600",
		            "name":"淮北市"
		        },
		        {
		            "id":"340700",
		            "name":"铜陵市"
		        },
		        {
		            "id":"340800",
		            "name":"安庆市"
		        },
		        {
		            "id":"341000",
		            "name":"黄山市"
		        },
		        {
		            "id":"341100",
		            "name":"滁州市"
		        },
		        {
		            "id":"341200",
		            "name":"阜阳市"
		        },
		        {
		            "id":"341300",
		            "name":"宿州市"
		        },
		        {
		            "id":"341500",
		            "name":"六安市"
		        },
		        {
		            "id":"341600",
		            "name":"亳州市"
		        },
		        {
		            "id":"341700",
		            "name":"池州市"
		        },
		        {
		            "id":"341800",
		            "name":"宣城市"
		        },
		        {
		            "id":"350000",
		            "name":"福建省"
		        },
		        {
		            "id":"350100",
		            "name":"福州市"
		        },
		        {
		            "id":"350200",
		            "name":"厦门市"
		        },
		        {
		            "id":"350300",
		            "name":"莆田市"
		        },
		        {
		            "id":"350400",
		            "name":"三明市"
		        },
		        {
		            "id":"350500",
		            "name":"泉州市"
		        },
		        {
		            "id":"350600",
		            "name":"漳州市"
		        },
		        {
		            "id":"350700",
		            "name":"南平市"
		        },
		        {
		            "id":"350800",
		            "name":"龙岩市"
		        },
		        {
		            "id":"350900",
		            "name":"宁德市"
		        },
		        {
		            "id":"360000",
		            "name":"江西省"
		        },
		        {
		            "id":"360100",
		            "name":"南昌市"
		        },
		        {
		            "id":"360200",
		            "name":"景德镇市"
		        },
		        {
		            "id":"360300",
		            "name":"萍乡市"
		        },
		        {
		            "id":"360400",
		            "name":"九江市"
		        },
		        {
		            "id":"360500",
		            "name":"新余市"
		        },
		        {
		            "id":"360600",
		            "name":"鹰潭市"
		        },
		        {
		            "id":"360700",
		            "name":"赣州市"
		        },
		        {
		            "id":"360800",
		            "name":"吉安市"
		        },
		        {
		            "id":"360900",
		            "name":"宜春市"
		        },
		        {
		            "id":"361000",
		            "name":"抚州市"
		        },
		        {
		            "id":"361100",
		            "name":"上饶市"
		        },
		        {
		            "id":"370000",
		            "name":"山东省"
		        },
		        {
		            "id":"370100",
		            "name":"济南市"
		        },
		        {
		            "id":"370200",
		            "name":"青岛市"
		        },
		        {
		            "id":"370300",
		            "name":"淄博市"
		        },
		        {
		            "id":"370400",
		            "name":"枣庄市"
		        },
		        {
		            "id":"370500",
		            "name":"东营市"
		        },
		        {
		            "id":"370600",
		            "name":"烟台市"
		        },
		        {
		            "id":"370700",
		            "name":"潍坊市"
		        },
		        {
		            "id":"370800",
		            "name":"济宁市"
		        },
		        {
		            "id":"370900",
		            "name":"泰安市"
		        },
		        {
		            "id":"371000",
		            "name":"威海市"
		        },
		        {
		            "id":"371100",
		            "name":"日照市"
		        },
		        {
		            "id":"371300",
		            "name":"临沂市"
		        },
		        {
		            "id":"371400",
		            "name":"德州市"
		        },
		        {
		            "id":"371500",
		            "name":"聊城市"
		        },
		        {
		            "id":"371600",
		            "name":"滨州市"
		        },
		        {
		            "id":"371700",
		            "name":"菏泽市"
		        },
		        {
		            "id":"410000",
		            "name":"河南省"
		        },
		        {
		            "id":"410100",
		            "name":"郑州市"
		        },
		        {
		            "id":"410200",
		            "name":"开封市"
		        },
		        {
		            "id":"410300",
		            "name":"洛阳市"
		        },
		        {
		            "id":"410400",
		            "name":"平顶山市"
		        },
		        {
		            "id":"410500",
		            "name":"安阳市"
		        },
		        {
		            "id":"410600",
		            "name":"鹤壁市"
		        },
		        {
		            "id":"410700",
		            "name":"新乡市"
		        },
		        {
		            "id":"410800",
		            "name":"焦作市"
		        },
		        {
		            "id":"410900",
		            "name":"濮阳市"
		        },
		        {
		            "id":"411000",
		            "name":"许昌市"
		        },
		        {
		            "id":"411100",
		            "name":"漯河市"
		        },
		        {
		            "id":"411200",
		            "name":"三门峡市"
		        },
		        {
		            "id":"411300",
		            "name":"南阳市"
		        },
		        {
		            "id":"411400",
		            "name":"商丘市"
		        },
		        {
		            "id":"411500",
		            "name":"信阳市"
		        },
		        {
		            "id":"411600",
		            "name":"周口市"
		        },
		        {
		            "id":"411700",
		            "name":"驻马店市"
		        },
		        {
		            "id":"420000",
		            "name":"湖北省"
		        },
		        {
		            "id":"420100",
		            "name":"武汉市"
		        },
		        {
		            "id":"420200",
		            "name":"黄石市"
		        },
		        {
		            "id":"420300",
		            "name":"十堰市"
		        },
		        {
		            "id":"420500",
		            "name":"宜昌市"
		        },
		        {
		            "id":"420600",
		            "name":"襄阳市"
		        },
		        {
		            "id":"420700",
		            "name":"鄂州市"
		        },
		        {
		            "id":"420800",
		            "name":"荆门市"
		        },
		        {
		            "id":"420900",
		            "name":"孝感市"
		        },
		        {
		            "id":"421000",
		            "name":"荆州市"
		        },
		        {
		            "id":"421100",
		            "name":"黄冈市"
		        },
		        {
		            "id":"421200",
		            "name":"咸宁市"
		        },
		        {
		            "id":"421300",
		            "name":"随州市"
		        },
		        {
		            "id":"422800",
		            "name":"恩施土家族苗族自治州"
		        },
		        {
		            "id":"430000",
		            "name":"湖南省"
		        },
		        {
		            "id":"430100",
		            "name":"长沙市"
		        },
		        {
		            "id":"430200",
		            "name":"株洲市"
		        },
		        {
		            "id":"430300",
		            "name":"湘潭市"
		        },
		        {
		            "id":"430400",
		            "name":"衡阳市"
		        },
		        {
		            "id":"430500",
		            "name":"邵阳市"
		        },
		        {
		            "id":"430600",
		            "name":"岳阳市"
		        },
		        {
		            "id":"430700",
		            "name":"常德市"
		        },
		        {
		            "id":"430800",
		            "name":"张家界市"
		        },
		        {
		            "id":"430900",
		            "name":"益阳市"
		        },
		        {
		            "id":"431000",
		            "name":"郴州市"
		        },
		        {
		            "id":"431100",
		            "name":"永州市"
		        },
		        {
		            "id":"431200",
		            "name":"怀化市"
		        },
		        {
		            "id":"431300",
		            "name":"娄底市"
		        },
		        {
		            "id":"433100",
		            "name":"湘西土家族苗族自治州"
		        },
		        {
		            "id":"440000",
		            "name":"广东省"
		        },
		        {
		            "id":"440100",
		            "name":"广州市"
		        },
		        {
		            "id":"440200",
		            "name":"韶关市"
		        },
		        {
		            "id":"440300",
		            "name":"深圳市"
		        },
		        {
		            "id":"440400",
		            "name":"珠海市"
		        },
		        {
		            "id":"440500",
		            "name":"汕头市"
		        },
		        {
		            "id":"440600",
		            "name":"佛山市"
		        },
		        {
		            "id":"440700",
		            "name":"江门市"
		        },
		        {
		            "id":"440800",
		            "name":"湛江市"
		        },
		        {
		            "id":"440900",
		            "name":"茂名市"
		        },
		        {
		            "id":"441200",
		            "name":"肇庆市"
		        },
		        {
		            "id":"441300",
		            "name":"惠州市"
		        },
		        {
		            "id":"441400",
		            "name":"梅州市"
		        },
		        {
		            "id":"441500",
		            "name":"汕尾市"
		        },
		        {
		            "id":"441600",
		            "name":"河源市"
		        },
		        {
		            "id":"441700",
		            "name":"阳江市"
		        },
		        {
		            "id":"441800",
		            "name":"清远市"
		        },
		        {
		            "id":"441900",
		            "name":"东莞市"
		        },
		        {
		            "id":"442000",
		            "name":"中山市"
		        },
		        {
		            "id":"445100",
		            "name":"潮州市"
		        },
		        {
		            "id":"445200",
		            "name":"揭阳市"
		        },
		        {
		            "id":"445300",
		            "name":"云浮市"
		        },
		        {
		            "id":"450000",
		            "name":"广西壮族自治区"
		        },
		        {
		            "id":"450100",
		            "name":"南宁市"
		        },
		        {
		            "id":"450200",
		            "name":"柳州市"
		        },
		        {
		            "id":"450300",
		            "name":"桂林市"
		        },
		        {
		            "id":"450400",
		            "name":"梧州市"
		        },
		        {
		            "id":"450500",
		            "name":"北海市"
		        },
		        {
		            "id":"450600",
		            "name":"防城港市"
		        },
		        {
		            "id":"450700",
		            "name":"钦州市"
		        },
		        {
		            "id":"450800",
		            "name":"贵港市"
		        },
		        {
		            "id":"450900",
		            "name":"玉林市"
		        },
		        {
		            "id":"451000",
		            "name":"百色市"
		        },
		        {
		            "id":"451100",
		            "name":"贺州市"
		        },
		        {
		            "id":"451200",
		            "name":"河池市"
		        },
		        {
		            "id":"451300",
		            "name":"来宾市"
		        },
		        {
		            "id":"451400",
		            "name":"崇左市"
		        },
		        {
		            "id":"460000",
		            "name":"海南省"
		        },
		        {
		            "id":"460100",
		            "name":"海口市"
		        },
		        {
		            "id":"460200",
		            "name":"三亚市"
		        },
		        {
		            "id":"460300",
		            "name":"三沙市"
		        },
		        {
		            "id":"460400",
		            "name":"儋州市"
		        },
		        {
		            "id":"500000",
		            "name":"重庆市"
		        },
		        {
		            "id":"510000",
		            "name":"四川省"
		        },
		        {
		            "id":"510100",
		            "name":"成都市"
		        },
		        {
		            "id":"510300",
		            "name":"自贡市"
		        },
		        {
		            "id":"510400",
		            "name":"攀枝花市"
		        },
		        {
		            "id":"510500",
		            "name":"泸州市"
		        },
		        {
		            "id":"510600",
		            "name":"德阳市"
		        },
		        {
		            "id":"510700",
		            "name":"绵阳市"
		        },
		        {
		            "id":"510800",
		            "name":"广元市"
		        },
		        {
		            "id":"510900",
		            "name":"遂宁市"
		        },
		        {
		            "id":"511000",
		            "name":"内江市"
		        },
		        {
		            "id":"511100",
		            "name":"乐山市"
		        },
		        {
		            "id":"511300",
		            "name":"南充市"
		        },
		        {
		            "id":"511400",
		            "name":"眉山市"
		        },
		        {
		            "id":"511500",
		            "name":"宜宾市"
		        },
		        {
		            "id":"511600",
		            "name":"广安市"
		        },
		        {
		            "id":"511700",
		            "name":"达州市"
		        },
		        {
		            "id":"511800",
		            "name":"雅安市"
		        },
		        {
		            "id":"511900",
		            "name":"巴中市"
		        },
		        {
		            "id":"512000",
		            "name":"资阳市"
		        },
		        {
		            "id":"513200",
		            "name":"阿坝藏族羌族自治州"
		        },
		        {
		            "id":"513300",
		            "name":"甘孜藏族自治州"
		        },
		        {
		            "id":"513400",
		            "name":"凉山彝族自治州"
		        },
		        {
		            "id":"520000",
		            "name":"贵州省"
		        },
		        {
		            "id":"520100",
		            "name":"贵阳市"
		        },
		        {
		            "id":"520200",
		            "name":"六盘水市"
		        },
		        {
		            "id":"520300",
		            "name":"遵义市"
		        },
		        {
		            "id":"520400",
		            "name":"安顺市"
		        },
		        {
		            "id":"520500",
		            "name":"毕节市"
		        },
		        {
		            "id":"520600",
		            "name":"铜仁市"
		        },
		        {
		            "id":"522300",
		            "name":"黔西南布依族苗族自治州"
		        },
		        {
		            "id":"522600",
		            "name":"黔东南苗族侗族自治州"
		        },
		        {
		            "id":"522700",
		            "name":"黔南布依族苗族自治州"
		        },
		        {
		            "id":"530000",
		            "name":"云南省"
		        },
		        {
		            "id":"530100",
		            "name":"昆明市"
		        },
		        {
		            "id":"530300",
		            "name":"曲靖市"
		        },
		        {
		            "id":"530400",
		            "name":"玉溪市"
		        },
		        {
		            "id":"530500",
		            "name":"保山市"
		        },
		        {
		            "id":"530600",
		            "name":"昭通市"
		        },
		        {
		            "id":"530700",
		            "name":"丽江市"
		        },
		        {
		            "id":"530800",
		            "name":"普洱市"
		        },
		        {
		            "id":"530900",
		            "name":"临沧市"
		        },
		        {
		            "id":"532300",
		            "name":"楚雄彝族自治州"
		        },
		        {
		            "id":"532500",
		            "name":"红河哈尼族彝族自治州"
		        },
		        {
		            "id":"532600",
		            "name":"文山壮族苗族自治州"
		        },
		        {
		            "id":"532800",
		            "name":"西双版纳傣族自治州"
		        },
		        {
		            "id":"532900",
		            "name":"大理白族自治州"
		        },
		        {
		            "id":"533100",
		            "name":"德宏傣族景颇族自治州"
		        },
		        {
		            "id":"533300",
		            "name":"怒江傈僳族自治州"
		        },
		        {
		            "id":"533400",
		            "name":"迪庆藏族自治州"
		        },
		        {
		            "id":"540000",
		            "name":"西藏自治区"
		        },
		        {
		            "id":"540100",
		            "name":"拉萨市"
		        },
		        {
		            "id":"540200",
		            "name":"日喀则市"
		        },
		        {
		            "id":"540300",
		            "name":"昌都市"
		        },
		        {
		            "id":"540400",
		            "name":"林芝市"
		        },
		        {
		            "id":"540500",
		            "name":"山南市"
		        },
		        {
		            "id":"540600",
		            "name":"那曲市"
		        },
		        {
		            "id":"542500",
		            "name":"阿里地区"
		        },
		        {
		            "id":"610000",
		            "name":"陕西省"
		        },
		        {
		            "id":"610100",
		            "name":"西安市"
		        },
		        {
		            "id":"610200",
		            "name":"铜川市"
		        },
		        {
		            "id":"610300",
		            "name":"宝鸡市"
		        },
		        {
		            "id":"610400",
		            "name":"咸阳市"
		        },
		        {
		            "id":"610500",
		            "name":"渭南市"
		        },
		        {
		            "id":"610600",
		            "name":"延安市"
		        },
		        {
		            "id":"610700",
		            "name":"汉中市"
		        },
		        {
		            "id":"610800",
		            "name":"榆林市"
		        },
		        {
		            "id":"610900",
		            "name":"安康市"
		        },
		        {
		            "id":"611000",
		            "name":"商洛市"
		        },
		        {
		            "id":"620000",
		            "name":"甘肃省"
		        },
		        {
		            "id":"620100",
		            "name":"兰州市"
		        },
		        {
		            "id":"620200",
		            "name":"嘉峪关市"
		        },
		        {
		            "id":"620300",
		            "name":"金昌市"
		        },
		        {
		            "id":"620400",
		            "name":"白银市"
		        },
		        {
		            "id":"620500",
		            "name":"天水市"
		        },
		        {
		            "id":"620600",
		            "name":"武威市"
		        },
		        {
		            "id":"620700",
		            "name":"张掖市"
		        },
		        {
		            "id":"620800",
		            "name":"平凉市"
		        },
		        {
		            "id":"620900",
		            "name":"酒泉市"
		        },
		        {
		            "id":"621000",
		            "name":"庆阳市"
		        },
		        {
		            "id":"621100",
		            "name":"定西市"
		        },
		        {
		            "id":"621200",
		            "name":"陇南市"
		        },
		        {
		            "id":"622900",
		            "name":"临夏回族自治州"
		        },
		        {
		            "id":"623000",
		            "name":"甘南藏族自治州"
		        },
		        {
		            "id":"630000",
		            "name":"青海省"
		        },
		        {
		            "id":"630100",
		            "name":"西宁市"
		        },
		        {
		            "id":"630200",
		            "name":"海东市"
		        },
		        {
		            "id":"632200",
		            "name":"海北藏族自治州"
		        },
		        {
		            "id":"632300",
		            "name":"黄南藏族自治州"
		        },
		        {
		            "id":"632500",
		            "name":"海南藏族自治州"
		        },
		        {
		            "id":"632600",
		            "name":"果洛藏族自治州"
		        },
		        {
		            "id":"632700",
		            "name":"玉树藏族自治州"
		        },
		        {
		            "id":"632800",
		            "name":"海西蒙古族藏族自治州"
		        },
		        {
		            "id":"640000",
		            "name":"宁夏回族自治区"
		        },
		        {
		            "id":"640100",
		            "name":"银川市"
		        },
		        {
		            "id":"640200",
		            "name":"石嘴山市"
		        },
		        {
		            "id":"640300",
		            "name":"吴忠市"
		        },
		        {
		            "id":"640400",
		            "name":"固原市"
		        },
		        {
		            "id":"640500",
		            "name":"中卫市"
		        },
		        {
		            "id":"650000",
		            "name":"新疆维吾尔自治区"
		        },
		        {
		            "id":"650100",
		            "name":"乌鲁木齐市"
		        },
		        {
		            "id":"650200",
		            "name":"克拉玛依市"
		        },
		        {
		            "id":"650400",
		            "name":"吐鲁番市"
		        },
		        {
		            "id":"650500",
		            "name":"哈密市"
		        },
		        {
		            "id":"652300",
		            "name":"昌吉回族自治州"
		        },
		        {
		            "id":"652700",
		            "name":"博尔塔拉蒙古自治州"
		        },
		        {
		            "id":"652800",
		            "name":"巴音郭楞蒙古自治州"
		        },
		        {
		            "id":"652900",
		            "name":"阿克苏地区"
		        },
		        {
		            "id":"653000",
		            "name":"克孜勒苏柯尔克孜自治州"
		        },
		        {
		            "id":"653100",
		            "name":"喀什地区"
		        },
		        {
		            "id":"653200",
		            "name":"和田地区"
		        },
		        {
		            "id":"654000",
		            "name":"伊犁哈萨克自治州"
		        },
		        {
		            "id":"654200",
		            "name":"塔城地区"
		        },
		        {
		            "id":"654300",
		            "name":"阿勒泰地区"
		        },
		        {
		            "id":"710000",
		            "name":"台湾省"
		        },
		        {
		            "id":"810000",
		            "name":"香港特别行政区"
		        },
		        {
		            "id":"820000",
		            "name":"澳门特别行政区"
		        }
	],
	$cztdlist:[
		{
			jmxzMc:'10011605 地震造成纳税困难免土地税',
			num:'1',
		},{
			jmxzMc:'10011607 抗击疫情地方减免城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10011608 出租方为个体工商户减免租金减免城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10011705 棚户区改造安置住房建设用地免土地税',
			num:'1',
		},{
			jmxzMc:'10011708 易地扶贫搬迁安置住房用地免征城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10011709 公共租赁住房用地免土地税',
			num:'1',
		},{
			jmxzMc:'10012701 置残疾人就业单位用地减免土地税',
			num:'1',
		},{
			jmxzMc:'10012702 福利性非营利性老年服务机构土地免土地税',
			num:'1',
		},{
			jmxzMc:'10012703 社区养老、托育、家政机构免征城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10019902 农贸市场（集贸市场）用地免土地税',
			num:'1',
		},{
			jmxzMc:'10019903 落实私房政策后的房屋用地减免土地税',
			num:'1',
		},{
			jmxzMc:'10019908 农产品批发市场、农贸市场用地免土地税',
			num:'1',
		},{
			jmxzMc:'10019909 大宗商品仓储设施用地城镇土地使用税优惠',
			num:'1',
		},{
			jmxzMc:'10021901 非营利性科研机构自用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10021910 科技企业孵化器、大学科技园和众创空间免征城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10022002 转制科研机构的科研开发自用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10033301 青藏铁路公司及其所属单位自用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10049901 增值税小规模纳税人城镇土地使用税减征',
			num:'1',
		},{
			jmxzMc:'10052401 大秦公司市场化运作前其自用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10052402 广深公司承租广铁集团铁路运输用地免土地税',
			num:'1',
		},{
			jmxzMc:'10052403 企业搬迁原场地不使用的免土地税',
			num:'1',
		},{
			jmxzMc:'10052404 去产能和调结构政策关停企业免征城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10061001 企业厂区以外的公共绿化用地免土地税',
			num:'1',
		},{
			jmxzMc:'10061002 天然林二期工程专用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10061003 天然林二期工程森工企业闲置土地免土地税',
			num:'1',
		},{
			jmxzMc:'10064004 居民供热使用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10064201 电力行业部分用地免土地税',
			num:'1',
		},{
			jmxzMc:'10064202 核工业总公司所属企业部分用地免土地税',
			num:'1',
		},{
			jmxzMc:'10064203 核电站应税土地在基建期内减半征收土地使用税',
			num:'1',
		},{
			jmxzMc:'10064204 核电站部分用地免征土地税',
			num:'1',
		},{
			jmxzMc:'10083902 接收港澳国际（集团）有限公司的房产',
			num:'1',
		},{
			jmxzMc:'10083903 被撤销金融机构清算期间自有的或从债务方接收的房地产',
			num:'1',
		},{
			jmxzMc:'10083905 4家金融资产公司处置房地产免土地税',
			num:'1',
		},{
			jmxzMc:'10092303 农村饮水工程运营管理单位自用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10101401 学校、托儿所、幼儿园自用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10102901 符合条件的体育场馆减免城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10120401 大型民用客机发动机、中大功率民用涡轴涡桨发动机研制项目自用土地免征城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10120402 从事大型客机研制项目的纳税人及其全资子公司自用土地免征城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10120702 航空航天公司专属用地免土地税',
			num:'1',
		},{
			jmxzMc:'10121301 铁道部所属铁路运输企业自用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10121303 地方铁路运输企业自用土地免土地税',
			num:'1',
		},{
			jmxzMc:'10121304 港口的码头用地免土地税',
			num:'1',
		},{
			jmxzMc:'10121305 民航机场规定用地免土地税',
			num:'1',
		},{
			jmxzMc:'10121306 股改铁路运输企业及合资铁路运输公司自用的房产免土地税',
			num:'1',
		},{
			jmxzMc:'10121308 厂区外未加隔离的企业铁路专用线用地免土地税',
			num:'1',
		},{
			jmxzMc:'10121310 城市公交站场等运营用地免征城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10122602 国家石油储备基地第一期项目用地免土地税',
			num:'1',
		},{
			jmxzMc:'10122606 商品储备管理公司及其直属库自用土地免征城镇土地使用税',
			num:'1',
		},{
			jmxzMc:'10123401 血站自用的土地免土地税',
			num:'1',
		},{
			jmxzMc:'10123402 非营利性医疗，疾病控制，妇幼保健机构自用的土地免土地税',
			num:'1',
		},{
			jmxzMc:'10123403 营利性医疗机构自用的土地3年内免土地税',
			num:'1',
		},{
			jmxzMc:'10125002 免税单位无偿使用的土地免土地税',
			num:'1',
		},{
			jmxzMc:'10125003 劳改劳教单位相关用地免土地税',
			num:'1',
		},{
			jmxzMc:'10129901 地下建筑用地暂按50%征收免土地税',
			num:'1',
		},{
			jmxzMc:'10129902 采摘观光的种植养殖土地免土地税',
			num:'1',
		},{
			jmxzMc:'10129906 水利设施及其管护用地免土地税',
			num:'1',
		},{
			jmxzMc:'10129907 防火防爆防毒等安全用地免土地税',
			num:'1',
		},{
			jmxzMc:'10129909 矿山企业生产专用地免土地税',
			num:'1',
		},{
			jmxzMc:'10129910 煤炭企业规定用地免土地税',
			num:'1',
		},{
			jmxzMc:'10129911 盐场的盐滩盐矿的矿井用地免土地税',
			num:'1',
		},{
			jmxzMc:'10129913 林业系统相关用地免土地税',
			num:'1',
		},{
			jmxzMc:'10129917 纳税人困难性减免土地税',
			num:'1',
		},{
			jmxzMc:'10129918 开山填海整治土地和改造废弃土地免土地税',
			num:'1',
		},{
			jmxzMc:'10129919 企业已售房改房占地免土地税',
			num:'1',
		},{
			jmxzMc:'10129920 廉租房用地免土地税',
			num:'1',
		},{
			jmxzMc:'10129921 企业的荒山、林地、湖泊等占地减半征收土地税',
			num:'1',
		},{
			jmxzMc:'10129924 石油天然气生产企业部分用地免土地税',
			num:'1',
		},{
			jmxzMc:'10129999 其他',
			num:'1',
		}
	],
	$czfwlist:[
		{
			jmxzMc:'08011601 地震毁损不堪和危险房屋免房产税',
			ssjmxzhzDm:'08011601',
			num:'1',
		},{
			jmxzMc:'08011605 芦山因灾损毁的房产免征房产税',
			ssjmxzhzDm:'08011605',
			num:'2',
		},{
			jmxzMc:'08011606 鲁甸因灾损毁的房产免征房产税',
			ssjmxzhzDm:'08011606',
			num:'3',
		},{
			jmxzMc:'08011701 个人出租住房房产税暂减按4%的税率征收',
			ssjmxzhzDm:'08011701',
			num:'4',
		},{
			jmxzMc:'08011702 廉租住房租金收入免征房产税',
			ssjmxzhzDm:'08011702',
			num:'5',
		},{
			jmxzMc:'08011704 公共租赁住房免征房产税',
			ssjmxzhzDm:'08011704',
			num:'6',
		},{
			jmxzMc:'0008019902 《中华人民共和国房产税暂行条例》国发〔1986〕90号第六条',
			ssjmxzhzDm:'0008019902',
			num:'122',
		},{
			jmxzMc:'08012701 非营利性老年服务机构自用房产免征房产税',
			ssjmxzhzDm:'08012701',
			num:'7',
		},{
			jmxzMc:'08019901 农产品批发市场农贸市场房产免征房产税',
			ssjmxzhzDm:'08019901',
			num:'8',
		},{
			jmxzMc:'08019902 企业纳税困难减免房产税',
			ssjmxzhzDm:'08019902',
			num:'9',
		},{
			jmxzMc:'08021904 孵化器自用及提供孵化企业使用房产免征房产税',
			ssjmxzhzDm:'08021904',
			num:'10',
		},{
			jmxzMc:'08021905 科技园自用及提供孵化企业使用房产免征房产税',
			ssjmxzhzDm:'08021905',
			num:'11',
		},{
			jmxzMc:'08021906 非营利性科研机构自用的房产免征房产税',
			ssjmxzhzDm:'08021906',
			num:'12',
		},{
			jmxzMc:'08022001 转制科研机构的科研开发用房免征房产税',
			ssjmxzhzDm:'08022001',
			num:'12',
		},{
			jmxzMc:'08033301 青藏铁路公司及所属单位自用房产免征房产税',
			ssjmxzhzDm:'08033301',
			num:'13',
		},{
			jmxzMc:'08052401 大秦公司完全按市场化运作前其自用房产免征房产税',
			ssjmxzhzDm:'08052401',
			num:'14',
		},{
			jmxzMc:'8061002 天然林二期工程的专用房产免征房产税',
			ssjmxzhzDm:'8061002',
			num:'15',
		},{
			jmxzMc:'08061003 天然林二期工程森工企业闲置房产免征房产税',
			ssjmxzhzDm:'08061003',
			num:'16',
		},{
			jmxzMc:'08064001 为居民供热所使用的厂房免征房产税',
			ssjmxzhzDm:'08064001',
			num:'17',
		},{
			jmxzMc:'08081501 被撤销金融机构清算期间房地产免征房产税',
			ssjmxzhzDm:'08081501',
			num:'18',
		},{
			jmxzMc:'08083902 东方资产管理公司接收港澳国际（集团）有限公司的房地产免征房产税',
			ssjmxzhzDm:'08083902',
			num:'19',
		},{
			jmxzMc:'08083904 四家金融资产管理公司及分支机构处置不良资产免征房产税',
		},{
			jmxzMc:'08092301 农村饮水工程运营管理单位房产免征房产税',
		},{
			jmxzMc:'08101401 学校、托儿所、幼儿园自用的房产免征房产税',
		},{
			jmxzMc:'08101404 高校学生公寓免征房产税',
			ssjmxzhzDm:'08101404',
			num:'23',
		},{
			jmxzMc:'08103207 转制文化企业自用房产免征房产税',
			ssjmxzhzDm:'08103207',
			num:'24',
		},{
			jmxzMc:'08121302 铁路运输企业免征房产税',
			ssjmxzhzDm:'08121302',
			num:'25',
		},{
			jmxzMc:'08121304 股改铁路运输企业及合资铁路运输公司自用房产免征房产税',
			ssjmxzhzDm:'08121304',
			num:'26',
		},{
			jmxzMc:'08122602 商品储备业务自用房产免征房产税',
			ssjmxzhzDm:'08122602',num:'27',
		},{
			jmxzMc:'08123401 血站自用的房产免征房产税',
			ssjmxzhzDm:'08123401',num:'28',
		},{
			jmxzMc:'08123402 非营利性医疗机构、疾病控制机构和妇幼保健机构等卫生机构自用的房产免征房产税',
			ssjmxzhzDm:'08123402',num:'29',
		},{
			jmxzMc:'08123404 营利性医疗机构自用的房产，免征三年免征房产税',
			ssjmxzhzDm:'08123404',num:'30',
		},{
			jmxzMc:'08125001 国家财政拨付事业经费的劳教单位的自用房产免征房产税',
			ssjmxzhzDm:'08125001',num:'30',
		},{
			jmxzMc:'08125002 司法部门所属监狱等房产免征房产税',
			ssjmxzhzDm:'08125002',num:'31',
		},{
			jmxzMc:'08129903 毁损房屋和危险房屋免征房产税',
			ssjmxzhzDm:'08129903',num:'32',
		},{
			jmxzMc:'08129906 工商行政管理部门的集贸市场用房免征房产税',
			ssjmxzhzDm:'08129906',num:'33',
		},{
			jmxzMc:'08129907 房管部门经租非营业用房免征房产税',
			ssjmxzhzDm:'08129907',num:'34',
		},{
			jmxzMc:'08129913 地下建筑减征房产税',
			ssjmxzhzDm:'08129913',num:'35',
		},{
			jmxzMc:'08129915 基建工地临时性房屋免征房产税',
			ssjmxzhzDm:'08129915',num:'36',
		},{
			jmxzMc:'08129916 大修停用的房产免征房产税',
			ssjmxzhzDm:'08129916',num:'37',
		},{
			jmxzMc:'08129999 将职工住宅全部产权出售给本单位职工的房产免征房产税',
			ssjmxzhzDm:'08129999',num:'38',
		},{
			jmxzMc:'08129999 发后填式水电站电厂房减征房产税',
			ssjmxzhzDm:'08129999',num:'39',
		},
		{
			jmxzMc:'08129999 中国人民银行总行（含国家外汇管理局）所属分支机构自用的房产免征房产税',
			ssjmxzhzDm:'08129999',num:'40',
		},
		{
			jmxzMc:'08129999 公共事业用房产免征房产税',
			ssjmxzhzDm:'08129999',num:'41',
		},
		{
			jmxzMc:'08129999 其他',
			ssjmxzhzDm:'08129999',num:'42',
		},
		{
			jmxzMc:'08129999 专为武警内部人员及其家属服务的房产免征房产税',
			ssjmxzhzDm:'08129999',num:'43',
		}
	],
	$yhslist: [{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900092",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于调整房地产交易环节税收政策的通知》 财税〔2008〕137号第二条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011701",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对个人销售或购买住房暂免征收印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900105",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于廉租住房经济适用住房和住房租赁有关税收政策的通知》 财税〔2008〕24号第一条第（四）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011702",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对廉租住房、经济适用住房经营管理单位与廉租住房、经济适用住房相关的印花税以及廉租住房承租人、经济适用住房购买人涉及的印花税予以免征",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900024",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于棚户区改造有关税收政策的通知》 财税〔2013〕101号第一条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011704",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "保障性住房免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900103",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于廉租住房经济适用住房和住房租赁有关税收政策的通知》 财税〔2008〕24号第一条第（四）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011706",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对开发商建造廉租房和经济适用住房有关印花税予以免征",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900322",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于廉租住房经济适用住房和住房租赁有关税收政策的通知》 财税〔2008〕24号第二条第（二）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011707",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "免征个人出租承租住房签订的租赁合同印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901000",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于易地扶贫搬迁税收优惠政策的通知》 财税〔2018〕135号第二条第（一）款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011711",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "易地扶贫搬迁实施主体取得安置住房土地免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901001",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于易地扶贫搬迁税收优惠政策的通知》 财税〔2018〕135号第二条第（二）款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011712",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "易地扶贫搬迁安置住房建设和分配过程中免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901002",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于易地扶贫搬迁税收优惠政策的通知》 财税〔2018〕135号第二条第（五）款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011713",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "易地扶贫搬迁实施主体安置住房房源免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900097",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于公共租赁住房税收优惠政策的公告》 财政部 税务总局公告2019年第61号第二条、第三条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011714",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对公租房经营管理单位建造、管理公租房、购买住房作为公租房免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900095",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于公共租赁住房税收优惠政策的公告》 财政部 税务总局公告2019年第61号第三条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009011715",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对公共租赁住房双方免征租赁协议印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900119",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《国家税务局关于印花税若干具体问题的规定》 （88）国税地字第025号第三条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009012701",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "房地产管理部门与个人订立的租房合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900461",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《国家税务局关于印花税若干具体问题的规定》 （88）国税地字第025号第六条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009012702",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "铁路、公路、航运、水路承运快件行李、包裹开具的托运单据免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900972",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于全国社会保障基金有关投资业务税收政策的通知》 财税〔2018〕94号第三条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009012703",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "社保基金会、社保基金投资管理人管理的社保基金转让非上市公司股权，免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900974",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于基本养老保险基金有关投资业务税收政策的通知》 财税〔2018〕95号第三条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009012704",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "社保基金会、养老基金投资管理机构管理的养老基金转让非上市公司股权，免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901097",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 人力资源社会保障部 国资委 税务总局 证监会关于全面推开划转部分国有资本充实社保基金工作的通知》 财资〔2019〕49号附件第五条第（二十四）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009012705",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "划转非上市公司股份的，对划出方与划入方签订的产权转移书据免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901098",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 人力资源社会保障部 国资委 税务总局 证监会关于全面推开划转部分国有资本充实社保基金工作的通知》 财资〔2019〕49号附件第五条第（二十四）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009012706",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "划转上市公司股份和全国中小企业股份转让系统挂牌公司股份的，免征证券交易印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901099",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 人力资源社会保障部 国资委 税务总局 证监会关于全面推开划转部分国有资本充实社保基金工作的通知》 财资〔2019〕49号附件第五条第（二十四）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009012707",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对划入方因承接划转股权而增加的实收资本和资本公积，免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900255",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于支持小微企业融资有关税收政策的通知》 财税〔2017〕77号第二条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009041503",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对金融机构与小型企业、微型企业签订的借款合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900362",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于中国邮政储蓄银行改制上市有关税收政策的通知》 财税〔2013〕53号第五条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009052401",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "企业改制、重组过程中印花税予以免征",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900738",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于组建中国铁路总公司有关印花税政策的通知》 财税〔2015〕57号",
			"jmzlxDm": "",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009052501",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对中国铁路总公司改革过程中涉及的印花税进行减免",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901097",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于企业改制重组及事业单位改制有关印花税政策的公告》 财政部 税务总局公告2024年第14号 第三条第三款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009052513",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "同一投资主体内部划转股权书立的产权转移书据，免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900362",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于明确中国邮政集团公司邮政速递物流业务重组改制过程中有关契税和印花税政策的通知》 财税〔2010〕92号第二、三、四条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009059901",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "企业改制、重组过程中印花税予以免征",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900362",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于企业改制过程中有关印花税政策的通知》 财税〔2003〕183号",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009059902",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "企业改制、重组过程中印花税予以免征",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900107",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于中国联合网络通信集团有限公司转让CDMA网及其用户资产企业合并资产整合过程中涉及的增值税营业税印花税和土地增值税政策问题的通知》 财税〔2011〕13号第五、六、七条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009059903",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对企业改制、资产整合过程中涉及的所有产权转移书据及股权转让协议印花税予以免征",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900104",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于中国联合网络通信集团有限公司转让CDMA网及其用户资产企业合并资产整合过程中涉及的增值税营业税印花税和土地增值税政策问题的通知》 财税〔2011〕13号第八条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009059904",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对联通新时空移动通信有限公司接受中国联合网络通信集团固定通信资产增加资本金涉及的印花税予以免征",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900089",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于中国移动集团股权结构调整及盈余公积转增实收资本有关印花税政策的通知》 财税〔2012〕62号第一、二条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009059905",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对2011年中国移动增加的资本公积、股权调整协议、盈余公积转增实收资本印花税予以免征",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900315",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于对买卖封闭式证券投资基金继续予以免征印花税的通知》 财税〔2004〕173号",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081502",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "买卖封闭式证券投资基金免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900188",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于股权分置试点改革有关税收政策问题的通知》 财税〔2005〕103号第一条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081503",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "股权分置改革过程中发生的股权转让免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900457",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于国家开发银行缴纳印花税问题的复函 》 财税字〔1995〕47号第一条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081504",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "贴息贷款合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900216",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于境内证券市场转持部分国有股充实全国社会保障基金有关证券（股票）交易印花税政策的通知》 财税〔2009〕103号",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081505",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "国有股东向全国社会保障基金理事会转持国有股免征证券（股票）交易印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900362",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于外国银行分行改制为外商独资银行有关税收问题的通知》 财税〔2007〕45号第三条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081509",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "企业改制、重组过程中印花税予以免征",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900496",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于信贷资产证券化有关税收政策问题的通知》 财税〔2006〕5号第一条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081510",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "信贷资产证券化免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900550",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于证券投资者保护基金有关印花税政策的通知》 财税〔2006〕104号",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081512",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "证券投资者保护基金免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900025",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于被撤销金融机构有关税收政策问题的通知》 财税〔2003〕141号第二条第1项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081516",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "被撤销金融机构接收债权、清偿债务签订的产权转移书据免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900960",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于保险保障基金有关税收政策问题的通知》 财税〔2018〕41号第二条第一款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081518",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "新设立的资金账簿免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900961",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于保险保障基金有关税收政策问题的通知》 财税〔2018〕41号第二条第二款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081519",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对保险公司进行风险处置和破产救助过程中签订的产权转移书据免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900962",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于保险保障基金有关税收政策问题的通知》 财税〔2018〕41号第二条第三款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081520",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对保险公司进行风险处置过程中与中国人民银行签订的再贷款合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900963",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于保险保障基金有关税收政策问题的通知》 财税〔2018〕41号第二条第四款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081521",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "以保险保障基金自有财产和接收的受偿资产与保险公司签订的财产保险合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901296",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（五）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081522",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "无息或者贴息借款合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901297",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（五）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009081523",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "国际金融组织向中国提供优惠贷款书立的借款合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900217",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于4家资产管理公司接收资本金项下的资产在办理过户时有关税收政策问题的通知》 财税〔2003〕21号",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009083901",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "国有商业银行划转给金融资产管理公司的资产免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900258",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于中国信达等4家金融资产管理公司税收政策问题的通知》 财税〔2001〕10号",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009083903",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "金融资产管理公司收购、承接、处置不良资产免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900335",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中国人民银行 农业部 国家发展计划委员会 财政部 国家税务总局关于免缴农村信用社接收农村合作基金会财产产权过户税费的通知》 银发〔2000〕21号",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009083904",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "农村信用社接受农村合作基金会财产产权转移书免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900113",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于中国信达资产管理股份有限公司等4家金融资产管理公司有关税收政策问题的通知》 财税〔2013〕56号第一条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009083906",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对中国信达资产管理股份有限公司、中国华融资产管理股份有限公司及其分支机构处置剩余政策性剥离不良资产以及出让上市公司股权免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900883",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于支持农村集体产权制度改革有关税收政策的通知》 财税〔2017〕55号第二条第二款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009092306",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "农村集体经济组织清产核资免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900519",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于继续实行农村饮水安全工程税收优惠政策的公告》 财政部 税务总局公告2019年第67号第二条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009092307",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "饮水工程运营管理单位为建设饮水工程取得土地使用权签订的产权转移书据，以及与施工单位签订的建设工程承包合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901294",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（四）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009092308",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "农民、家庭农场、农民专业合作社、农村集体经济组织、村民委员会购买农业生产资料或者销售农产品书立的买卖合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901295",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（四）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009092309",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "农民、家庭农场、农民专业合作社、农村集体经济组织、村民委员会购买农业生产资料或者销售农产品书立的农业保险合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900090",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 国家税务总局关于教育税收政策的通知》 财税〔2004〕39号第二条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009101401",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对财产所有人将财产赠给学校所书立的书据免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900156",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局关于高校学生公寓房产税 印花税政策的通知》 财税〔2019〕14号第二条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009101406",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "高校学生公寓租赁合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900895",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第一条第（九）款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102905",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对北京冬奥组委、北京冬奥会测试赛赛事组委会使用的营业账簿和签订的各类合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900903",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第二条第（二）款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102906",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对国际奥委会签订的与北京2022年冬奥会有关的各类合同，免征国际奥委会的印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900907",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第二条第（二）款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102907",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对中国奥委会签订的与北京2022年冬奥会有关的各类合同，免征中国奥委会的印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900911",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第二条第（五）款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102908",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对国际残奥委会取得的与北京2022年冬残奥会有关的收入免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900915",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第二条第（六）款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102909",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对中国残奥委会取得的由北京冬奥组委分期支付的收入免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900921",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第三条第（四）款",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102910",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对财产所有人将财产捐赠给北京冬奥组委所书立的产权转移书据免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901013",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于第七届世界军人运动会税收政策的通知》 财税〔2018〕119号 第二条第（三）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102911",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对财产所有人将财产捐赠给执委会所书立的产权转移书据免征应缴纳的印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901108",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收优惠政策的公告》 财政部公告2019年第92号第六条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102912",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "国际奥委会相关实体与北京冬奥组委签订的各类合同，免征国际奥委会相关实体应缴纳的印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901138",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于杭州2022年亚运会和亚残运会税收政策的公告》 财政部公告2020年第18号第七条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102913",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对杭州2022年亚运会和亚残运会及其测试赛组委会使用的营业账簿和签订的各类合同等应税凭证，免征组委会应缴纳的印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901139",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于杭州2022年亚运会和亚残运会税收政策的公告》 财政部公告2020年第18号第八条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102914",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对财产所有人将财产(物品)捐赠给杭州2022年亚运会和亚残运会及其测试赛组委会所书立的产权转移书据，免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901140",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于第18届世界中学生运动会等三项国际综合运动会税收政策的公告》 财政部公告2020年第19号第七条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102915",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对三项国际综合运动会的执行委员会、组委会使用的营业账簿和签订的各类合同等应税凭证免征执行委员会、组委会应缴纳的印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901141",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《财政部 税务总局 海关总署关于第18届世界中学生运动会等三项国际综合运动会税收政策的公告》 财政部公告2020年第19号第八条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009102916",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "对财产所有人将财产(物品)捐赠给三项国际综合运动会的执行委员会、组委会所书立的产权转移书据，免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900115",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《国家税务局关于图书、报刊等征订凭证征免印花税问题的通知》 （89）国税地字第142号第二条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009103201",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "发行单位之间，发行单位与订阅单位或个人之间书立的征订凭证，暂免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900479",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《关于继续实施文化体制改革中经营性文化事业单位转制为企业若干税收政策的通知》 财税〔2019〕16号第一条第（四）项",
			"jmzlxDm": "01",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009103204",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "文化单位转制为企业时的印花税优惠",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901298",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（六）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009120602",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "财产所有权人将财产赠与政府、学校、社会福利机构、慈善组织书立的产权转移书据免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901293",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（三）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009120702",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "中国人民解放军、中国人民武装警察部队书立的应税凭证免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031900282",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《国家税务总局关于货运凭证征收印花税几个具体问题的通知》 国税发〔1990〕173号",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009121301",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "特殊货运凭证免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901084",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《关于延续执行部分国家商品储备税收优惠政策的公告》 财政部 税务总局公告2022年第8号第一条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009122606",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "商品储备管理公司及其直属库资金账簿免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901085",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《关于延续执行部分国家商品储备税收优惠政策的公告》 财政部 税务总局公告2022年第8号第一条",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009122607",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "商品储备管理公司及其直属库承担商品储备业务购销合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901292",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（二）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009123101",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "依照法律规定应当予以免税的外国驻华使馆、领事馆和国际组织驻华代表机构为获得馆舍书立的应税凭证免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901299",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（七）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009123402",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "非营利性医疗卫生机构采购药品或者卫生材料书立的买卖合同免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901291",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（一）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009129908",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "应税凭证的副本或者抄本免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031901300",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "《中华人民共和国印花税法》 中华人民共和国主席令第89号第十二条第（八）项",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 0,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009129909",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "个人与电子商务经营者订立的电子订单免征印花税",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		},
		{
			"fpzlDms": [

			],
			"jmfd": "1",
			"jmfsDm": "",
			"jmlxDm": "",
			"jmqxq": "",
			"jmqxz": "",
			"jmsspsxDm": "SXA031999999",
			"jmwjDm": 0,
			"jmxmDm": "",
			"jmxmMc": "",
			"jmxzDm": "",
			"jmxzMc": "其他",
			"jmzlxDm": "02",
			"jzed": 0,
			"jzfd": 1,
			"jzsl": 0,
			"nsqxDm": "",
			"sl": "",
			"spbm": "",
			"ssjmxzdlDm": "",
			"ssjmxzhzDm": "0009129999",
			"ssjmxzxlDm": "",
			"ssjmyyDm": "",
			"ssjmzlDm": "",
			"swsxMc": "其他",
			"sysl": "",
			"xgbz": "",
			"yhpzuuid": "",
			"zspmDm": "",
			"zspmmc": "",
			"zsxmDm": "10111"
		}
	],
	$smzm: [{
			"sl1": "0.000050",
			"value": "101110108",
			"label": "借款合同",
			"zszm": [{
					"sl1": "0.000050",
					"value": "101110108YH22001",
					"label": "银行业金融机构借款合同"
				},
				{
					"sl1": "0.000050",
					"value": "101110108YH22002",
					"label": "其他金融机构借款合同"
				}
			]
		},
		{
			"sl1": "0.001000",
			"value": "101110109",
			"label": "财产保险合同",
			"zszm": [

			]
		},
		{
			"sl1": "0.000300",
			"value": "101110110",
			"label": "技术合同",
			"zszm": [{
					"sl1": "0.000300",
					"value": "101110110YH22001",
					"label": "技术开发合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110110YH22002",
					"label": "技术许可合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110110YH22003",
					"label": "技术咨询合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110110YH22004",
					"label": "技术服务合同"
				}
			]
		},
		{
			"sl1": "0.000300",
			"value": "101110111",
			"label": "买卖合同",
			"zszm": [

			]
		},
		{
			"sl1": "0.000300",
			"value": "101110112",
			"label": "承揽合同",
			"zszm": [{
					"sl1": "0.000300",
					"value": "101110112YH22001",
					"label": "加工合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110112YH22002",
					"label": "定作合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110112YH22003",
					"label": "修理合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110112YH22004",
					"label": "复制合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110112YH22005",
					"label": "测试合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110112YH22006",
					"label": "检验合同"
				}
			]
		},
		{
			"sl1": "0.000300",
			"value": "101110113",
			"label": "建设工程合同",
			"zszm": [{
					"sl1": "0.000300",
					"value": "101110113YH22001",
					"label": "工程勘察合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110113YH22002",
					"label": "工程设计合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110113YH22003",
					"label": "工程施工合同"
				}
			]
		},
		{
			"sl1": "0.001000",
			"value": "101110114",
			"label": "租赁合同",
			"zszm": [{
					"sl1": "0.001000",
					"value": "101110114YH22001",
					"label": "房屋租赁合同"
				},
				{
					"sl1": "0.001000",
					"value": "101110114YH22002",
					"label": "其他租赁合同"
				}
			]
		},
		{
			"sl1": "0.000300",
			"value": "101110115",
			"label": "运输合同",
			"zszm": [{
					"sl1": "0.000300",
					"value": "101110115YH22001",
					"label": "公路货物运输合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110115YH22002",
					"label": "水路货物运输合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110115YH22003",
					"label": "航空货物运输合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110115YH22004",
					"label": "铁路货物运输合同"
				},
				{
					"sl1": "0.000300",
					"value": "101110115YH22005",
					"label": "多式联运合同"
				}
			]
		},
		{
			"sl1": "0.001000",
			"value": "101110116",
			"label": "保管合同",
			"zszm": [

			]
		},
		{
			"sl1": "0.001000",
			"value": "101110117",
			"label": "仓储合同",
			"zszm": [

			]
		},
		{
			"sl1": "0.000050",
			"value": "101110118",
			"label": "融资租赁合同",
			"zszm": [

			]
		},
		{
			"sl1": "0.000500",
			"value": "101110200",
			"label": "产权转移书据",
			"zszm": [{
					"sl1": "0.000500",
					"value": "101110200YH22001",
					"label": "土地使用权出让书据"
				},
				{
					"sl1": "0.000500",
					"value": "101110200YH22002",
					"label": "土地使用权转让书据"
				},
				{
					"sl1": "0.000500",
					"value": "101110200YH22003",
					"label": "房屋等建筑物和构筑物所有权转让书据（不包括土地承包经营权和土地经营权转移）"
				},
				{
					"sl1": "0.000500",
					"value": "101110200YH22004",
					"label": "股权转让书据（不包括应缴纳证券交易印花税的）"
				},
				{
					"sl1": "0.000300",
					"value": "101110200YH22005",
					"label": "商标专用权转让书据"
				},
				{
					"sl1": "0.000300",
					"value": "101110200YH22006",
					"label": "著作权转让书据"
				},
				{
					"sl1": "0.000300",
					"value": "101110200YH22007",
					"label": "专利权转让书据"
				},
				{
					"sl1": "0.000300",
					"value": "101110200YH22008",
					"label": "专有技术使用权转让书据"
				}
			]
		},
		{
			"sl1": "0.000250",
			"value": "101110502",
			"label": "营业账簿",
			"zszm": [

			]
		},{
			"sl1": "0.10000",
			"value": "101119800",
			"label": "其他凭证",
			"zszm": [

			]
		}
	],
	$bbztsb: [
		{
			label: "草稿",
			value: "0"
		},
		{
			label: "未填写",
			value: "-1"
		},
		{
			label: "底稿",
			value: "1",
			color: "#6DC0FF"
		},
		{
			label: "提交中",
			value: "2",
			color: "#F7B500"
		},
		{
			label: "审核成功",
			value: "3",
			color: "#0065B1"
		},
		{
			label: "审核失败",
			value: "4",
			color: "#E02020"
		},
		{
			label: "申报中",
			value: "5",
			color: "#F7B500"
		},
		{
			label: "申报成功",
			value: "6",
			color: "#048E00"
		},
		{
			label: "申报失败",
			value: "7",
			color: "#E02020"
		},
		// {
		// 	label: "申报作废",
		// 	value: "8"
		// },
		{
			label: "缴款成功",
			value: "9",
		},
		{
			label: "缴款失败",
			value: "10",
			color: "#E02020"
		},
		{
			label: "缴款中",
			value: "11",
			color: "#F7B500"
		},
		{
			label: "申报作废中",
			value: "12",
			color: "#F7B500"
		},
		// {
		// 	label: "草稿",
		// 	value: "13"
		// },
		{
			label: "作废成功",
			value: "14",
			color: "#0065B1"
		},
		{
			label: "取消审核",
			value: "15",
			color: "#F7B500"
		},
		// {
		// 	label: "发起PDF下载",
		// 	value: "16"
		// },
		{
			label: "作废失败",
			value: "17",
			color: "#E02020"
		},
		// {
		// 	label: "PDF下载失败",
		// 	value: "18"
		// }
		{
			label: "申报更正中",
			value: "22",
			color: "#F7B500"
		},
		{
			label: "申报更正失败",
			value: "23",
			color: "#E02020"
		},
		{
			label: "申报更正",
			value: "24",
			color: "#F7B500"
		},
	],
	$gaosbz: [{
		label: "不包含",
		value: "0"
	}, {
		label: "包含",
		value: "1"
	}],
	$jizbz: [{
			label: "已记账",
			value: "1"
		},
		{
			label: "未记账",
			value: "0"
		}
	],
	$cztds:[
		{
			label: "居民身份证",
			value: "201"
		},{
			label: "军官证",
			value: "202"
		},{
			label: "武警警官证",
			value: "203"
		},{
			label: "士兵证",
			value: "204"
		},{
			label: "军队离退休干部证",
			value: "205"
		},{
			label: "残疾人证",
			value: "206"
		},{
			label: "残疾军人证（1-8级）",
			value: "207"
		},{
			label: "外国护照",
			value: "208"
		},{
			label: "港澳同胞回乡证",
			value: "209"
		},{
			label: "港澳居民来往内地通行证",
			value: "210"
		},{
			label: "台胞证",
			value: "211"
		},{
			label: "中华人民共和国往来港澳通行证",
			value: "212"
		},{
			label: "台湾居民来往大陆通行证",
			value: "213"
		},{
			label: "大陆居民往来台湾通行证",
			value: "214"
		},{
			label: "外国人居留证",
			value: "215"
		},{
			label: "外交官证",
			value: "216"
		},{
			label: "领事馆证",
			value: "217"
		},{
			label: "海员证",
			value: "218"
		},{
			label: "香港身份证",
			value: "219"
		},{
			label: "台湾身份证",
			value: "220"
		},{
			label: "澳门身份证",
			value: "221"
		},{
			label: "外国人身份证件",
			value: "222"
		},{
			label: "高校毕业生自主创业证",
			value: "223"
		},{
			label: "就业失业登记证",
			value: "224"
		},{
			label: "退休证",
			value: "225"
		},{
			label: "离休证",
			value: "226"
		},{
			label: "中国护照",
			value: "227"
		},{
			label: "城镇退役士兵自谋职业证",
			value: "228"
		},{
			label: "外国人永久居留证",
			value: "233"
		},{
			label: "就业创业证",
			value: "234"
		},{
			label: "医学出生证明",
			value: "291"
		},{
			label: "其他个人证件",
			value: "299"
		}
	],
	$fplx: [{
			label: "电子专票",
			value: "028"
		},
		{
			label: "电子普票",
			value: "026"
		}, {
			label: "纸质普票",
			value: "007"
		},
		{
			label: "纸质专票",
			value: "004"
		}
	],
	$Dikbz: [{
			label: "已抵扣",
			value: "1"
		},
		{
			label: "未抵扣",
			value: "0"
		}
	],
	$ywzx: [
		{
			label: "销项税会差异",
			value: "1"
		},
		{
			label: "进项税会差异",
			value: "2"
		},
	],
	$zxzt: [
		{
			label: "未开始",
			value: "0"
		},
		{
			label: "成功",
			value: "1"
		},
		{
			label: "失败",
			value: "2"
		}
	],
	$step: [
		{
			label: "跨月账期初始化",
			value: "1"
		},
		{
			label: "获取清册数据",
			value: "2"
		},
		{
			label: "税局数据下载",
			value: "3"
		},
		{
			label: "申报状态更新",
			value: "4"
		},
		{
			label: "税务采集任务",
			value: "5"
		},
		{
			label: "发票数据下载",
			value: "6"
		},
		{
			label: "发票抵扣数据下载",
			value: "7"
		},
		{
			label: "代扣代缴数据下载",
			value: "8"
		},
		{
			label: "海关缴款书数据下载",
			value: "9"
		}
	],
	$dsrwType: [
		{
			label: "批量处理跨月事件",
			value: "1"
		},
		{
			label: "批量处理通知",
			value: "2"
		},
		{
			label: "未知",
			value: "3"
		},
		{
			label: "数据下载",
			value: "4"
		}
	],
	$ywfw: [
		{
			label: "销项",
			value: "1"
		},
		{
			label: "进项",
			value: "2"
		},
	],
	$qzfw: [
		{
			label: "仅发票",
			value: "1"
		},
		{
			label: "仅凭证",
			value: "2"
		},
		{
			label: "发票+凭证",
			value: "3"
		},
		{
			label: "发票 / 凭证",
			value: "4"
		}
	],
	$flag: [
		{
			label: "否",
			value: "0"
		},
		{
			label: "是",
			value: "1"
		}
	],
	$taskStatus: [
		{
			label: "正常",
			value: "0"
		},
		{
			label: "暂停",
			value: "1"
		}
	],
	$sjlx: [
		{
			label: "初始化",
			value: "0"
		},
		{
			label: "手工",
			value: "1"
		}
	],
	$bbztdg: [{
			label: "未填写",
			value: "0"
		},
		{
			label: "底稿",
			value: "1"
		},
		{
			label: "审核中",
			value: "2"
		},
		{
			label: "审核成功",
			value: "3"
		},
		{
			label: "审核失败",
			value: "4"
		},
		{
			label: "申报中",
			value: "5"
		},
		{
			label: "申报成功",
			value: "6"
		},
		{
			label: "申报失败",
			value: "7"
		},
		{
			label: "申报作废",
			value: "8"
		},
		{
			label: "缴款成功",
			value: "9"
		},
		{
			label: "缴款失败",
			value: "10"
		}
	],
	$resultlist: [{
			label: "成功",
			value: "1"
		},
		{
			label: "部分成功",
			value: "2"
		},
		{
			label: "失败",
			value: "3"
		}
	],
	$declareTypeMapping: [{
			label: "增值税",
			value: "1"
		},
		{
			label: "企业所得税",
			value: "11"
		},
		{
			label: "财产和行为税",
			value: "15"
		},
		{
			label: "财务报表",
			value: "3"
		},
		{
			label: "消费税",
			value: "30"
		}
	],
	$declarationMethodMapping: [{
		label: "零申报 - 系统申报",
		value: "1"
	},
	{
		label: "零申报 - 线下申报",
		value: "2"
	},
	{
		label: "非零申报",
		value: "0"
	}],
	$sourceFlagMapping: [{
			label: "科目余额表",
			value: "1"
		},
		{
			label: "票据信息", //财务凭证
			value: "2"
		},
		{
			label: "明细登记",
			value: "3"
		},
		{
			label: "汇总填写",
			value: "4"
		},
		{
			label: "税局数据",
			value: "5"
		},
		{
			label: "标准公式",
			value: "6"
		},
		{
			label: "手工填写",
			value: "7"
		},
		{
			label: "SAP取数",
			value: "8"
		},
		{
			label: "不填写",
			value: "9"
		},{
			label: "固定值",
			value: "20"
		},
		{
			label: "自定义公式",
			value: "0"
		}
	],
	$ComputationalLogic: [{
			label: "+",
			value: "+"
		},
		{
			label: "-",
			value: "-"
		},

	],
	$ShujlyMapping: [{
			label: "明细登记",
			value: "3"
		},
		{
			label: "科目余额表",
			value: "1"
		}
	],
	/*无票收入数据来源*/
	$WpsrShujlyMapping: [{
			label: "汇总填写",
			value: "4"
		},
		{
			label: "明细登记",
			value: "3"
		},
		{
			label: "科目余额表",
			value: "1"
		}
	],
	$Renzbz: [{
		label: "未认证",
		value: "0"
	}, {
		label: "已认证",
		value: "1"
	}],
	$biaoz: [{
		label: "代开",
		value: "0"
	}, {
		label: "农产品收购",
		value: "1"
	}, {
		label: "农产品加计扣除",
		value: "2"
	}, {
		label: "通行费",
		value: "3"
	}, {
		label: "成品油",
		value: "4"
	}, {
		label: "机动车",
		value: "5"
	}],
	$BenqzcbsMapping: [{
			label: "未转出",
			value: "0"
		},
		{
			label: "已转出",
			value: "1"
		}
	],
	$Faplx: [
		{
			label: "电子专用发票",
			value: "028"
		},
		{
			label: "电子普通发票",
			value: "026"
		},{
			label: "纸质专用发票",
			value: "004"
		},{
			label: "纸质普通发票",
			value: "007"
		},{
			label: "代扣代缴",
			value: "dkdj"
		},{
			label: "海关缴款书",
			value: "hgjks"
		},
	
	],
	$sszskzclx: [{
		label: "公告",
		value: "1"
	}, {
		label: "解读",
		value: "2"
	}, {
		label: "指南",
		value: "3"
	}, {
		label: "指引",
		value: "4"
	}, {
		label: "通知",
		value: "5"
	}, {
		label: "问答",
		value: "6"
	}, {
		label: "规定",
		value: "7"
	}, {
		label: "决定",
		value: "8"
	}, {
		label: "办法",
		value: "9"
	}, {
		label: "目录",
		value: "10"
	}, {
		label: "其他",
		value: "11"
	}],
	$sjly: [{
		label: "科目余额表",
		value: "1"
	}, {
		label: "票据信息",
		value: "2"
	}, {
		label: "明细登记",
		value: "3"
	}, {
		label: "汇总填写",
		value: "4"
	}, {
		label: "税局数据",
		value: "5"
	}, {
		label: "标准公式",
		value: "6"
	}, {
		label: "手工填写",
		value: "7"
	}, {
		label: "SAP取数",
		value: "8"
	}, {
		label: "不填写",
		value: "9"
	}, {
		label: "自定义公式",
		value: "0"
	}, ],
	$zbdl: [{
		label: "税收监控",
		value: "0"
	}],
	$zblx: [{
		value: '0',
		label: '税负率指标'
	}, {
		value: '1',
		label: '销售指标'
	}, {
		value: '2',
		label: '存货指标'
	}, {
		value: '3',
		label: '预收账款指标'
	}, {
		value: '4',
		label: '期间费用指标'
	}, {
		value: '5',
		label: '黑名单管理'
	}, {
		value: '6',
		label: '其他'
	}],
	$xgsz: [{
		value: '1',
		label: '增值税'
	}, {
		value: '2',
		label: '消费税'
	}, {
		value: '3',
		label: '企业所得税'
	}, {
		value: '4',
		label: '个人所得税'
	}, {
		value: '5',
		label: '资源税'
	}, {
		value: '6',
		label: '城市维护建设税'
	}, {
		value: '7',
		label: '房产税'
	}, {
		value: '8',
		label: '印花税'
	}, {
		value: '9',
		label: '城镇土地使用税'
	}, {
		value: '10',
		label: '土地增值税'
	}, {
		value: '11',
		label: '车船税'
	}, {
		value: '12',
		label: '车辆购置税'
	}, {
		value: '13',
		label: '烟叶税'
	}, {
		value: '14',
		label: '耕地占用税'
	}, {
		value: '15',
		label: '契税'
	}, {
		value: '16',
		label: '环境保护税'
	}, {
		value: '17',
		label: '进出口税收'
	}],
	//开放权限
	$kfqx: [
		{
			value: '1',
			label: '私有'
		}, {
			value: '2',
			label: '相同税号共享'
		}, {
			value: '3',
			label: '集团共享'
		}
	],
	$optionxfs: [{
			label: "烟",
			value: "101020100",
			children: [{
					label: "卷烟（调拨价70元（不含增值税）/条以上（含70元），从价计算）",
					value: "101020101",
					type: "1",
					shuil: "0.56",
					jldw:"万支"
				},
				{
					label: "卷烟（调拨价70元（不含增值税）/条以下，从价计算）",
					value: "101020102",
					type: "1",
					shuil: "0.36",
					jldw:"万支"
				},
				{
					label: "卷烟（调拨价70元（不含增值税）/条以上（含70元），从量计算）",
					value: "101020104",
					type: "2",
					shuil: "30",
					jldw:"万支"
				},
				{
					label: "卷烟（调拨价70元（不含增值税）/条以下，从量计算）",
					value: "101020105",
					type: "2",
					shuil: "30",
					jldw:"万支"
				},
				{
					label: "卷烟（商业批发，从价计算）",
					value: "101020106",
					type: "1",
					shuil: "0.11",
					jldw:"万支"
				},
				{
					label: "雪茄烟",
					value: "101020107",
					type: "1",
					shuil: "0.36",
					jldw:"支"
				},
				{
					label: "烟丝",
					value: "101020108",
					type: "1",
					shuil: "0.30",
					jldw:"千克"
				},
				{
					label: "卷烟（商业批发，从量计算）",
					value: "101020109",
					type: "2",
					shuil: "50",
					jldw:"万支"
				},
				{
					label: "电子烟（生产环节，从价计征）",
					value: "101020110",
					disabled: true
				},
				{
					label: "电子烟（批发环节，从价计征）",
					value: "101020111",
					disabled: true
				},
			]
		},
		{
			label: "酒",
			value: "101020200",
			children: [{
					label: "粮食白酒（从价计算）",
					value: "101020201",
					type: "1",
					shuil: "0.20",
					jldw:"500克（毫升）"
				},
				{
					label: "粮食白酒（从量计算）",
					value: "101020202",
					type: "2",
					shuil: "0.5",
					jldw:"500克（毫升）"
				},
				{
					label: "薯类白酒（从价计算）",
					value: "101020203",
					type: "1",
					shuil: "0.20",
					jldw:"500克（毫升）"
				},
				{
					label: "薯类白酒（从量计算）",
					value: "101020204",
					type: "2",
					shuil: "0.5",
					jldw:"500克（毫升）"
				},
				{
					label: "黄酒",
					value: "101020205",
					type: "2",
					shuil: "240",
					jldw:"吨"
				},
				{
					label: "啤酒（3000元/吨以上）",
					value: "101020206",
					type: "2",
					shuil: "250",
					jldw:"吨"
				},
				{
					label: "啤酒（3000元/吨以下）",
					value: "101020207",
					type: "2",
					shuil: "220",
					jldw:"吨"
				},
				{
					label: "酒精",
					value: "101020208",
					disabled: true
				},
				{
					label: "其他酒",
					value: "101020299",
					type: "1",
					shuil: "0.10",
					jldw:"吨"
				},
	
			]
		},
		{
			label: "化妆品",
			value: "101020300",
			disabled: true
		},
		{
			label: "首饰和珠宝玉石",
			value: "101020400",
			children: [{
					label: "金银首饰（铂金首饰、钻石及钻石饰品）",
					value: "101020401",
					type: "1",
					shuil: "0.05"
				},
				{
					label: "其他金银首饰及珠宝玉石",
					value: "101020499",
					type: "1",
					shuil: "0.10"
				},
			]
		},
		{
			label: "鞭炮、焰火",
			value: "101020500",
			type: "1",
			shuil: "0.15"
		},
		{
			label: "成品油",
			value: "101020600",
			children: [{
					label: "含铅汽油",
					value: "101020601",
					type: "2",
					shuil: "1.52",
					jldw:"升"
				},
				{
					label: "无铅汽油",
					value: "101020602",
					type: "2",
					shuil: "1.52",
					jldw:"升"
				},
				{
					label: "柴油",
					value: "101020603",
					type: "2",
					shuil: "1.20",
					jldw:"升"
				},
				{
					label: "航空煤油",
					value: "101020604",
					type: "2",
					shuil: "1.20",
					jldw:"升"
				},
				{
					label: "石脑油",
					value: "101020605",
					type: "2",
					shuil: "1.52",
					jldw:"升"
				},
				{
					label: "溶剂油",
					value: "101020606",
					type: "2",
					shuil: "1.52",
					jldw:"升"
				},
				{
					label: "润滑油",
					value: "101020607",
					type: "2",
					shuil: "1.52",
					jldw:"升"
				},
				{
					label: "燃料油",
					value: "101020608",
					type: "2",
					shuil: "1.20",
					jldw:"升"
				},
				{
					label: "汽油",
					value: "101020609",
					type: "2",
					shuil: "1.52",
					jldw:"升"
				},
	
			]
		},
		{
			label: "汽车轮胎",
			value: "101020700",
			disabled: true,
			children: [{
					label: "子午线轮胎",
					value: "101020701",
					disabled: true
				},
				{
					label: "斜交胎",
					value: "101020702",
					disabled: true
				},
				{
					label: "内胎",
					value: "101020703",
					disabled: true
				},
				{
					label: "其他汽车轮胎",
					value: "101020799",
					disabled: true
				},
	
			]
		},
		{
			label: "摩托车",
			value: "101020800",
			children: [{
					label: "250毫升（含）以下的摩托车",
					value: "101020801",
					disabled: true
				},
				{
					label: "250毫升（不含）以上摩托车",
					value: "101020802",
					type: "1",
					shuil: "0.10",
					jldw:"辆"
				},
				{
					label: "250毫升摩托车",
					value: "101020803",
					type: "1",
					shuil: "0.03",
					jldw:"辆"
				},
	
			]
		},
		{
			label: "乘用车",
			value: "101020900",
			children: [{
					label: "1.0升（含）以下的乘用车",
					value: "101020901",
					type: "1",
					shuil: "0.01",
					jldw:"辆"
				},
				{
					label: "1.0升以上至1.5升(含)的乘用车",
					value: "101020902",
					type: "1",
					shuil: "0.03",
					jldw:"辆"
				},
				{
					label: "1.5升以上至2.0升(含)的乘用车",
					value: "101020903",
					type: "1",
					shuil: "0.05",
					jldw:"辆"
				},
				{
					label: "2.0升以上至2.5升(含)的乘用车",
					value: "101020904",
					type: "1",
					shuil: "0.09",
					jldw:"辆"
				},
				{
					label: "2.5升以上至3.0升(含)的乘用车",
					value: "101020905",
					type: "1",
					shuil: "0.12",
					jldw:"辆"
				},
				{
					label: "3.0升以上至4.0升(含)的乘用车",
					value: "101020906",
					type: "1",
					shuil: "0.25",
					jldw:"辆"
				},
				{
					label: "4.0升以上的乘用车",
					value: "101020907",
					type: "1",
					shuil: "0.40",
					jldw:"辆"
				},
	
			]
		},
		{
			label: "中轻型商用客车",
			value: "101021000",
			type: "1",
			shuil: "0.05",
					jldw:"辆"
		},
		{
			label: "高尔夫球及球具",
			value: "101021100",
			type: "1",
			shuil: "0.10"
		},
		{
			label: "高档手表",
			value: "101021200",
			type: "1",
			shuil: "0.20",
					jldw:"只"
		},
		{
			label: "游艇",
			value: "101021300",
			type: "1",
			shuil: "0.10",
					jldw:"艘"
		},
		{
			label: "木制一次性筷子",
			value: "101021400",
			type: "1",
			shuil: "0.05",
					jldw:"万双"
		},
		{
			label: "实木地板",
			value: "101021500",
			type: "1",
			shuil: "0.05",
					jldw:"平方米"
		},
		{
			label: "电池",
			value: "101021600",
			children: [{
					label: "电池（不含铅蓄电池）",
					value: "101021601",
					type: "1",
					shuil: "0.04",
					jldw:"只"
				}, {
					label: "铅蓄电池",
					value: "101021699",
					type: "1",
					shuil: "0.04",
					jldw:"只"
				},
	
			]
		},
		{
			label: "涂料",
			value: "101021700",
			type: "1",
			shuil: "0.04",
					jldw:"吨"
		},
		{
			label: "高档化妆品",
			value: "101021800",
			type: "1",
			shuil: "0.15"
		},
		{
			label: "超豪华小汽车",
			value: "101021900",
			children: [{
				label: "超豪华乘用车",
				value: "101021901",
				type: "1",
				shuil: "0.10",
					jldw:"辆"
			}, {
				label: "超豪华中轻型商用客车",
				value: "101021902",
				type: "1",
				shuil: "0.05",
					jldw:"辆"
			}]
		},
	],
	// 处理状态
	$businessMatchStatus: [
		{
			label: "未匹配",
			value: "0"
		},
		{
			label: "匹配完成",
			value: "1"
		},
		{
			label: "暂不处理",
			value: "2"
		}
	],
	$fapzl: [
		{
			label: "数电发票",
			value: "0"
		},
		{
			label: "税控发票",
			value: "1"
		}
	],
	$jzjtbs: [
		{
			label: "全额即征即退",
			value: "1"
		},
		{
			label: "部分即征即退",
			value: "2"
		},
		{
			label: "非即征即退",
			value: "3"
		}
	],
	$apportionmentMethod: [
		{
			label: "全额分摊",
			value: "1"
		},
		{
			label: "销售比例分摊",
			value: "2"
		},
		{
			label: "实际成本分摊",
			value: "3"
		},
		{
			label: "手工分摊",
			value: "4"
		},
		{
			label: "暂不分摊",
			value: "5"
		},
		{
			label: "待分摊",
			value: "6"
		}
	],
	$isLock: [
		{
			value: '1',
			label: '已锁定'
		}, {
			value: '0',
			label: '未锁定'
		}
	],
	$iinvSjclzxFaplx: [
		{
			label: "电子专用发票",
			value: "028"
		},
		{
			label: "电子普通发票",
			value: "026"
		},
		{
			label: "纸质专用发票",
			value: "004"
		},
		{
			label: "纸质普通发票",
			value: "007"
		},
		{
			label: "航空运输电子客票行程单",
			value: "xcd"
		},
		{
			label: "火车票",
			value: "hcp"
		},
		{
			label: "代扣代缴",
			value: "dkdj"
		},
		{
			label: "海关缴款书",
			value: "hgjks"
		},
	],
}

comMapping.$provinceOptions = comMapping.$kszjgxzqhdmdata
	.filter(item => item.id.slice(2) === "0000")
	.map(item => ({
		label: item.name,
		value: item.name
	}))

export {
	comMapping
}
